import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react';

interface UI {
  open: boolean;
  left: boolean;
}

const UIContext = createContext<{
  ui: UI;
  setUI: Dispatch<SetStateAction<UI>>;
}>(undefined!);

export const useUI = () => {
  const context = useContext(UIContext);
  return context || { ui: { open: true } };
};

export const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [ui, setUI] = useState<UI>({ open: false, left: false });

  return (
    <UIContext.Provider value={{ ui, setUI }}>{children}</UIContext.Provider>
  );
};
